"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seoPopularCategory = void 0;
exports.seoPopularCategory = [
    { id: 1, name: 'Exotic', key: 'exotic' },
    { id: 2, name: 'Luxury', key: 'luxury' },
    { id: 3, name: 'Sport', key: 'sport' },
    { id: 4, name: 'Electric', key: 'electric' },
    { id: 5, name: 'Plugin Hybrid', key: 'phev' },
    { id: 6, name: 'Off Road', key: 'offRoad' },
    { id: 7, name: 'Fuel Efficient', key: 'fuelEfficient' },
];
